// Limits and labels of the Template tab. They mirror reminder_library/template/controller.js.

export const CODE_RE = /^[A-Z][A-Z0-9_]{1,49}$/;
export const LOCALE_RE = /^[a-z]{2}(-[A-Z]{2})?$/;
// Order of the variable groups in the chip list.
export const VARIABLE_GROUPS = ["User", "Recipient", "Project", "Record", "Parameter", "Company", "Reminder", "Digest"];
export const DIGEST_SNIPPET = "{{cases.length}} pending: {{#cases}} {{row.title}} ({{user.name}}) {{/cases}}";
